import { Dialog as MuiDialog, type DialogProps as MuiDialogProps, IconButton } from '@mui/material'
import type { PropsWithChildren } from 'react'
import CloseIcon from '~assets/icons/closeModal.svg'

export type ModalProps = PropsWithChildren<MuiDialogProps>

export const QRCodeModalContainer = (
	{ children, onClose, sx, ...props }: ModalProps
) => {
	return (
		<MuiDialog
			onClose={onClose}
			maxWidth='sm'
			sx={{
				...{
					'& .MuiDialog-paper': {
						borderRadius: '16px',
						position: 'relative',
						width: '100%',
						overflow: 'visible'
					}
				},
				...sx
			}}
			{...props}
		>
			{children}
			<IconButton
				aria-label='close'
				onClick={(event) => onClose?.(event, 'escapeKeyDown')}
				sx={{
					position: 'absolute',
					bottom: '-88px',
					left: '50%',
					transform: 'translateX(-50%)',
					backgroundColor: 'surface.light40',
					width: '56px',
					height: '56px'
				}}
			>
				<CloseIcon height={'20px'} width={'20px'} />
			</IconButton>
		</MuiDialog>
	)
}
